import * as z from "zod";

export const getPackingSlipWeatherWarnings = {
  name: "getPackingSlipWeatherWarnings" as const,
  input: z.intersection(
    z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
    z.object({ templateId: z.string().optional() }),
  ),
  output: z.object({ ordersMissingWeather: z.array(z.string()) }),
};
